import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/shell/PageHeader';
import { StandaloneFrame } from '@/shell/StandaloneFrame';
import { usePageTitle } from '@/shell/usePageTitle';

/**
 * What a not-found page says under its heading. A detail page that learns its record is absent
 * (or unshared — a 404 never says which, MM-D-05) keeps its own `PageHeader` (so the `h1` and its
 * focus survive) with the not-found title, and renders this under it.
 */
export function NotFoundBody() {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t('notFound.body')}
      </Typography>
      <Link component={RouterLink} to="/">
        {t('common.goHome')}
      </Link>
    </>
  );
}

/** A missing record inside the shell keeps `PageHeader` so the shell is not wrapped twice. */
export function RecordNotFound() {
  const { t } = useTranslation();
  const title = usePageTitle({ title: t('notFound.title') });
  return (
    <>
      <PageHeader title={title} />
      <NotFoundBody />
    </>
  );
}

/** The catch-all route, outside the shell: brand bar, one `main`, one `h1`. */
export function NotFound() {
  const { t } = useTranslation();
  usePageTitle({ title: t('notFound.title') });
  return (
    <StandaloneFrame>
      <Typography variant="h1" gutterBottom>
        {t('notFound.title')}
      </Typography>
      <NotFoundBody />
    </StandaloneFrame>
  );
}
